(() => {
  const root = document.documentElement;
  const story = document.querySelector('.story');
  const jumps = [...document.querySelectorAll('.jump')];
  const chapters = [...document.querySelectorAll('.chapter-link.jump')];
  const previousChapter = document.querySelector('[data-book-previous]');
  const nextChapter = document.querySelector('[data-book-next]');
  const chapterStatus = document.querySelector('[data-book-status]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const curated = document.querySelector('.spread-curated');
  const builder = document.querySelector('.spread-builder');
  const guide = document.querySelector('.spread-guide');
  const stories = document.querySelector('.spread-stories');
  const aboutSpread = document.querySelector('.spread-about');
  const aboutDrawer = document.querySelector('.about-page');
  const compact = matchMedia('(max-width: 900px)');
  const mobilePages = [document.querySelector('.home-panel'), curated, builder, guide, stories, aboutSpread];
  const mobileProgress = [0, .20, .49, .73, .88, .985];
  const mobilePageFor = progress => mobilePages[mobileProgress.reduce((best, value, index) => Math.abs(value - progress) < Math.abs(mobileProgress[best] - progress) ? index : best, 0)];

  function placeAboutBook() {
    const book = document.querySelector('.about-page .about-book');
    if (book && aboutSpread) aboutSpread.querySelector('.about-book-slot').append(book);
  }
  placeAboutBook();
  root.classList.add('has-about-drawer');
  document.addEventListener('shopify:section:load', placeAboutBook);
  let target = 0;
  let current = 0;
  let frame = 0;

  const clamp = value => Math.min(1, Math.max(0, value));
  const smooth = value => value * value * (3 - 2 * value);
  const range = (value, start, end) => clamp((value - start) / (end - start));

  function syncNavigation(active) {
    chapters.forEach((chapter, index) => {
      chapter.classList.toggle('active', index === active);
      if (index === active) chapter.setAttribute('aria-current', 'location');
      else chapter.removeAttribute('aria-current');
    });
    if (previousChapter) previousChapter.disabled = active === 0;
    if (nextChapter) nextChapter.disabled = active === chapters.length - 1;
    if (chapterStatus && chapters[active]) {
      const label = `${active + 1} / ${chapters.length} · ${chapters[active].querySelector('strong').textContent.trim()}`;
      if (chapterStatus.textContent !== label) chapterStatus.textContent = label;
    }
  }

  function moveChapter(direction) {
    const active = chapters.reduce((best, chapter, index) => Math.abs(Number(chapter.dataset.progress) - target) < Math.abs(Number(chapters[best].dataset.progress) - target) ? index : best, 0);
    const next = chapters[Math.max(0, Math.min(chapters.length - 1, active + direction))];
    if (next) goTo(Number(next.dataset.progress));
  }

  function read() {
    const distance = Math.max(1, story.offsetHeight - innerHeight);
    target = clamp((scrollY - story.offsetTop) / distance);
  }

  function paint() {
    if (compact.matches) {
      current = target;
      let active = 0;
      mobilePages.forEach((page, index) => { if (page.getBoundingClientRect().top <= innerHeight * .35) active = index; });
      mobilePages.slice(1).forEach(page => { page.style.pointerEvents = 'auto'; });
      syncNavigation(active);
      if (aboutDrawer) {
        aboutDrawer.classList.toggle('is-open', active === 5);
        aboutDrawer.inert = active !== 5;
        aboutDrawer.setAttribute('aria-hidden', String(active !== 5));
      }
      frame = 0;
      return;
    }
    const delta = target - current;
    current = reducedMotion.matches ? target : current + delta * .18;
    if (Math.abs(delta) < .0002) current = target;

    const open = smooth(range(current, .02, .16));
    const homeOpacity = 1 - smooth(range(current, .06, .12));
    const curatedEnter = smooth(range(current, .06, .13));
    const curatedExit = smooth(range(current, .27, .35));
    const spreadOpacity = curatedEnter * (1 - smooth(range(current, .34, .40)));
    const contentOpacity = smooth(range(current, .12, .18)) * (1 - smooth(range(current, .27, .33)));
    const turningOpacity = Math.sin(Math.PI * range(current, .025, .16));
    const spreadScale = .82 + smooth(range(current, .12, .18)) * .18 - curatedExit * .18;
    const pageRotate = -176 * smooth(range(current, .03, .16));
    const builderExit = smooth(range(current, .53, .60));
    const builderOpacity = smooth(range(current, .32, .42)) * (1 - smooth(range(current, .58, .66)));
    const builderContent = smooth(range(current, .41, .49)) * (1 - smooth(range(current, .53, .59)));
    const builderScale = .82 + smooth(range(current, .41, .49)) * .18 - builderExit * .18;
    const turningThreeOpacity = Math.sin(Math.PI * range(current, .29, .46));
    const pageThreeRotate = -176 * smooth(range(current, .30, .46));
    const guideExit = smooth(range(current, .77, .84));
    const guideOpacity = smooth(range(current, .57, .67)) * (1 - smooth(range(current, .82, .88)));
    const guideContent = smooth(range(current, .66, .73)) * (1 - smooth(range(current, .77, .83)));
    const guideScale = .82 + smooth(range(current, .66, .73)) * .18 - guideExit * .18;
    const turningFourOpacity = Math.sin(Math.PI * range(current, .53, .70));
    const pageFourRotate = -176 * smooth(range(current, .54, .70));
    const storiesExit = smooth(range(current, .91, .96));
    const storiesOpacity = smooth(range(current, .80, .87)) * (1 - storiesExit);
    const storiesContent = smooth(range(current, .85, .90)) * (1 - storiesExit);
    const storiesScale = .82 + smooth(range(current, .85, .90)) * .18 - storiesExit * .18;
    const turningFiveOpacity = Math.sin(Math.PI * range(current, .75, .93));
    const pageFiveRotate = -176 * smooth(range(current, .76, .93));
    const aboutOpacity = smooth(range(current, .90, .94));
    const aboutContent = smooth(range(current, .91, .96));
    const aboutScale = .82 + aboutContent * .18;
    const turningSixOpacity = Math.sin(Math.PI * range(current, .91, .985));
    const pageSixRotate = -176 * smooth(range(current, .92, .985));

    root.style.setProperty('--turn', open.toFixed(4));
    root.style.setProperty('--home-opacity', homeOpacity.toFixed(4));
    root.style.setProperty('--spread-opacity', spreadOpacity.toFixed(4));
    root.style.setProperty('--content-opacity', contentOpacity.toFixed(4));
    root.style.setProperty('--turning-opacity', Math.max(0, turningOpacity).toFixed(4));
    root.style.setProperty('--spread-scale', spreadScale.toFixed(4));
    root.style.setProperty('--page-rotate', `${pageRotate.toFixed(2)}deg`);
    root.style.setProperty('--builder-opacity', builderOpacity.toFixed(4));
    root.style.setProperty('--builder-content', builderContent.toFixed(4));
    root.style.setProperty('--builder-scale', builderScale.toFixed(4));
    root.style.setProperty('--turning-three-opacity', Math.max(0, turningThreeOpacity).toFixed(4));
    root.style.setProperty('--page-three-rotate', `${pageThreeRotate.toFixed(2)}deg`);
    root.style.setProperty('--guide-opacity', guideOpacity.toFixed(4));
    root.style.setProperty('--guide-content', guideContent.toFixed(4));
    root.style.setProperty('--guide-scale', guideScale.toFixed(4));
    root.style.setProperty('--turning-four-opacity', Math.max(0, turningFourOpacity).toFixed(4));
    root.style.setProperty('--page-four-rotate', `${pageFourRotate.toFixed(2)}deg`);
    root.style.setProperty('--stories-opacity', storiesOpacity.toFixed(4));
    root.style.setProperty('--stories-content', storiesContent.toFixed(4));
    root.style.setProperty('--stories-scale', storiesScale.toFixed(4));
    root.style.setProperty('--turning-five-opacity', Math.max(0, turningFiveOpacity).toFixed(4));
    root.style.setProperty('--page-five-rotate', `${pageFiveRotate.toFixed(2)}deg`);
    root.style.setProperty('--about-opacity', aboutOpacity.toFixed(4));
    root.style.setProperty('--about-content', aboutContent.toFixed(4));
    root.style.setProperty('--about-scale', aboutScale.toFixed(4));
    root.style.setProperty('--turning-six-opacity', Math.max(0, turningSixOpacity).toFixed(4));
    root.style.setProperty('--page-six-rotate', `${pageSixRotate.toFixed(2)}deg`);

    curated.style.pointerEvents = spreadOpacity > .92 && current < .27 ? 'auto' : 'none';
    builder.style.pointerEvents = builderOpacity > .92 && current < .53 ? 'auto' : 'none';
    guide.style.pointerEvents = guideOpacity > .92 && current < .77 ? 'auto' : 'none';
    stories.style.pointerEvents = storiesOpacity > .92 && current < .93 ? 'auto' : 'none';
    aboutSpread.style.pointerEvents = aboutOpacity > .92 ? 'auto' : 'none';
    if (aboutDrawer) {
      const drawerOpen = current >= .975;
      aboutDrawer.classList.toggle('is-open', drawerOpen);
      aboutDrawer.inert = !drawerOpen;
      aboutDrawer.setAttribute('aria-hidden', String(!drawerOpen));
    }
    syncNavigation(current < .09 ? 0 : current < .35 ? 1 : current < .62 ? 2 : current < .86 ? 3 : current < .95 ? 4 : 5);

    if (Math.abs(target - current) > .0002) frame = requestAnimationFrame(paint);
    else frame = 0;
  }

  function update() {
    read();
    if (!frame) frame = requestAnimationFrame(paint);
  }

  function goTo(progress) {
    if (compact.matches) {
      mobilePageFor(progress).scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    const distance = story.offsetHeight - innerHeight;
    scrollTo({ top: story.offsetTop + distance * progress, behavior: 'instant' });
    update();
  }

  jumps.forEach(button => button.addEventListener('click', () => goTo(Number(button.dataset.progress || 0))));
  previousChapter?.addEventListener('click', () => moveChapter(-1));
  nextChapter?.addEventListener('click', () => moveChapter(1));
  document.querySelectorAll('.duration-list a').forEach(link => link.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      location.assign(link.href);
      return;
    }
    curated.classList.add('is-leaving');
    setTimeout(() => location.assign(link.href), 700);
  }));
  document.querySelectorAll('.single-select button').forEach(button => button.addEventListener('click', () => {
    button.parentElement.querySelectorAll('button').forEach(option => option.classList.toggle('selected', option === button));
  }));
  document.querySelectorAll('.interest-grid button, .multi-select button').forEach(button => button.addEventListener('click', () => button.classList.toggle('selected')));
  addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);

  const chapterProgress = { home: 0, 'curated-tours': .20, 'build-your-beijing': .49, 'beijing-guide': .73, stories: .88, about: .985 };
  const requestedChapter = new URLSearchParams(location.search).get('chapter') || (location.hash === '#about' ? 'about' : null);
  read();
  current = target;
  paint();
  if (requestedChapter && Object.hasOwn(chapterProgress, requestedChapter)) {
    history.scrollRestoration = 'manual';
    const restoreChapter = () => setTimeout(() => {
      const distance = Math.max(0, story.offsetHeight - innerHeight);
      if (compact.matches) mobilePageFor(chapterProgress[requestedChapter]).scrollIntoView({ block: 'start' });
      else scrollTo(0, story.offsetTop + distance * chapterProgress[requestedChapter]);
      read();
      current = target;
      paint();
    }, 100);
    if (document.readyState === 'complete') restoreChapter();
    else addEventListener('load', restoreChapter, { once: true });
  }
})();

